import { render, staticRenderFns } from "./Liquidacion.vue?vue&type=template&id=7145a8bf&scoped=true"
import script from "./Liquidacion.vue?vue&type=script&lang=js"
export * from "./Liquidacion.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion.vue?vue&type=style&index=0&id=7145a8bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145a8bf",
  null
  
)

export default component.exports